export default __webpack_public_path__ + "static/IconOrderOnlineHere-wht-30b9ebaedf04f8d5b46f1aeb8a1d4ef2.png";